import React, { useState, useEffect, useRef } from 'react'
import chipsIcon from './TableChipsIcons' // Assuming you have an icon library for chips
import GetBuyInAfterBankrupt from './GetBuyInAfterBankrupt'

const ChipsStack = ({ buyIn, currentBet, smallBlind, className, participant, roomData, user, toggleGetChips, socket, width, showBetChips }) => {
  const chipDenominations = [ 1000000, 500000, 100000, 50000, 10000, 1000, 500, 100, 50, 25, 20, 10, 5, 2, 1 ]
  const [ buyInChips, setBuyInChips ] = useState([ [], [], [], [] ])
  const [ betChips, setBetChips ] = useState([ [], [], [] ]) // Initial five arrays
  const prevBuyInRef = useRef( null ) // Ref to store previous buyIn value
  const byuInIsChanged = ()=>{ return( prevBuyInRef.current !== buyIn )}
  const allArraysAreEmpty = buyInChips.every( stack => stack.length === 0 )
  const arraysForBuyInChips = ()=>{ if( width <= 1000 ){ return 3 }else{ return 4 }}
  const allArraysAreFilled = buyInChips.reduce((sum, stack) => sum + stack.reduce((stackSum, item) => stackSum + item, 0), 0) >= arraysForBuyInChips * 15
  const [ chipsStack, setChipsStack ] = useState( null )
  const [ betStack, setBetStack ] = useState( null )

  useEffect( ()=>{
    // if currentBet is empty, empty betChips 
    if( showBetChips && !currentBet || currentBet == 0 ){
      setBetChips( [ [], [], [] ] )
    }

    // if currentBet is > 0 and betChips is empty, generate chips for betChips
    if( showBetChips && currentBet && currentBet > 0 ){
      setBetChips(()=>{  
        return( generateChips( currentBet, betChips, 3, smallBlind ) )
      })
    }
  }, [ currentBet ])


  useEffect( () => {

    if( allArraysAreEmpty && Number.isInteger( buyIn ) ){
      if( buyIn && prevBuyInRef.current !== buyIn && Number.isInteger( buyIn ) ){
        const chps = generateChips( buyIn, buyInChips, arraysForBuyInChips(), smallBlind )
        prevBuyInRef.current = buyIn
        if( chps && chps.length ){
          setBuyInChips( chps )
        }
      }
    }

    if( allArraysAreFilled && Number.isInteger( buyIn ) ){
      if( buyIn && prevBuyInRef.current !== buyIn && Number.isInteger( buyIn ) ){
        const chps = generateChips( buyIn, [ [], [], [], [] ], arraysForBuyInChips(), smallBlind )
        prevBuyInRef.current = buyIn
        if( chps && chps.length ){
          setBuyInChips( chps )
        }
      }
    }

    if( Number( buyIn ) === 0 && prevBuyInRef.current !== 0 ){
      setBuyInChips([ [], [], [], [] ])
      prevBuyInRef.current = Number( buyIn )
    }

    if( byuInIsChanged() ) updateChips( smallBlind )

    let html = ( array, postfix )=>{
      return(
        array.map(( stack, stackIndex ) => (
          <div key={ stackIndex } className={`chip-stack stack-${ stackIndex + ( postfix ||  null ) }`}>
            { stack.map(( chipValue, chipIndex ) => (
              <div
                key={ chipIndex }
                className="chip"
                style={ width && width < 1000 ? { bottom: `${ chipIndex * 0.4 }rem` } : { bottom: `${ chipIndex * 0.25 }rem` }} // Adjust the increment (6px) as needed
                dangerouslySetInnerHTML={{ __html: chipsIcon[ chipValue ] }} // Insert SVG icon
              />
            ))}
          </div>
        ))
      )
    }

    setChipsStack( html( buyInChips, '' ))
    showBetChips ? setBetStack( html( betChips, '-bet' )) : null


  },[ buyIn, buyInChips, betChips, currentBet ])



  function updateChips ( smallBlind ) {
    
    if( buyIn ){

      // if value is bigger, just add chips
      if( buyIn > prevBuyInRef.current ){
        // console.log( 'add ' + ( buyIn - prevBuyInRef.current ) + ' to buyIn' )

        const chips2 = generateChips( buyIn - prevBuyInRef.current, buyInChips, arraysForBuyInChips(), smallBlind )
        if( chips2 && chips2.length ){
          setBuyInChips( chips2 )
        }
        // generateChips ( buyIn - prevBuyInRef.current )
      }
      
      // if value is less
      if( buyIn < prevBuyInRef.current ){
        // console.log( 'remove ' + ( prevBuyInRef.current - buyIn ) + ' from buyIn' )
        removeChips( prevBuyInRef.current - buyIn, smallBlind )
      }

      prevBuyInRef.current = buyIn
    }
  } 

  function removeChips( difference, smallBlind ) {
    // console.log( 'Diff is ' + difference )
    // let shouldStartNewIteration
    let unsortedFlatChips = JSON.parse( JSON.stringify( buyInChips )).flat() // Combine all numbers from the arrays
    let newBuyInChips = JSON.parse( JSON.stringify( buyInChips )) // Create a copy of buyIn
    let newBetChips = JSON.parse( JSON.stringify( betChips ))
    let chipsThatWereRemovedFromNewBuyIn = []
    let flatChips = sortFlatChips( unsortedFlatChips, smallBlind )

    // let closestSum = 0;
    let currentChipsSum = 0

    remove( smallBlind )

    function remove ( smallBlind ) {
      // console.log( 'Remove' )
      if( smallBlind ){
        let chipsThatEqualsToDifference

        // from flat chips collect chips that equal to diff 
        
        for( let t = 0; t < flatChips.length; t++) {
          if( flatChips[t] == difference ){
            chipsThatEqualsToDifference = flatChips[t]
            chipsThatWereRemovedFromNewBuyIn.push( chipsThatEqualsToDifference )
  
            for( let i = 0; i < newBuyInChips.length; i++ ) {
              let shouldBreak = false
              for( let m = 0; m <= newBuyInChips[i].length; m++) {
                if( Number( newBuyInChips[i][m] ) === Number( chipsThatEqualsToDifference )){
  
                  const randomArrayIndex = getRandomInt( 0, 3 ) // Choose a random array
                  showBetChips ? newBetChips[ randomArrayIndex ].push( newBuyInChips[i][m] ) : null
                  // console.log( 'Chips that added to newBetChips ' + newBuyInChips[i][m] )
  
                  // console.log( 'Remove from buyIn: ' + newBuyInChips[i][m] )
                  newBuyInChips[i].splice( m, 1 )
                  flatChips.splice( t, 1 )
    
                  shouldBreak = true
  
                  break;
                }
              }
              if( shouldBreak ) break
            }
            
            break
          }
        }
  
        if( !chipsThatEqualsToDifference ){
          for( let c = 0; c < flatChips.length; c++) {
  
            if( currentChipsSum + flatChips[c] <= difference ){
              currentChipsSum += flatChips[c];
      
              // Store chips that were removed
              chipsThatWereRemovedFromNewBuyIn.push( flatChips[c] )
                
              for( let i = 0; i < newBuyInChips.length; i++ ) {
                let shouldBreak = false
                for( let m = 0; m <= newBuyInChips[i].length; m++) {
                  if( Number( newBuyInChips[i][m] ) === Number( flatChips[c] )){
    
                    const randomArrayIndex = getRandomInt( 0, 3 ) // Choose a random array
                    showBetChips ? [ randomArrayIndex ].push( newBuyInChips[i][m] ) : null
                    // console.log( 'Chips that added to newBetChips ' + newBuyInChips[i][m] )
    
                    // console.log( 'Remove from buyIn: ' + newBuyInChips[i][m] )
                    newBuyInChips[i].splice( m, 1 )
                    flatChips.splice( c, 1 )
      
                    remove()
    
                    shouldBreak = true
    
                    break;
                  }
                }
                if( shouldBreak ) break
              }
            }else{
              break
            }
          }
  
          if( difference - currentChipsSum !== 0 ){
            // console.log( 'Some chip have to be split. Diff is ' +  ( Number( difference ) - Number( currentChipsSum ) ) )
      
            let chipToBeSplit
      
            // Find chip which value is higher then diff
            for( let a = 0; a < newBuyInChips.length; a++)  {
              let shoudBeBroken
              for( let c = 0; c < newBuyInChips[a].length; c++ ) {
      
                if( Number( newBuyInChips[a][c] ) >= (  Number( difference ) - Number( currentChipsSum ) ) ){
      
                  chipToBeSplit = newBuyInChips[a][c]
      
                  let chipsForReplacement = generateChips( Number( chipToBeSplit ) - ( Number( difference ) - Number( currentChipsSum ) ), newBuyInChips, 4, smallBlind, 60 )
      
                  // console.log( 'Chips that added to newBetChips ' + generateChips(( Number( difference ) - Number( currentChipsSum ) ), [[], [], [], []] ).toString(), 4, smallBlind, 60 )
                  
                  showBetChips ? newBetChips = generateChips( Number( difference ) - Number( currentChipsSum ), newBetChips, 3, smallBlind, 60 ) : null
      
                  // remove chipToBeSplit from new chips set
                  for (let s = 0; s < chipsForReplacement.length; s++) {
                    let shoudBeBroken1
                    for (let d = 0; d < chipsForReplacement[ s ].length; d++) {
                      if( Number( chipsForReplacement[s][d] ) == Number( chipToBeSplit )){
                        chipsForReplacement[s].splice( d, 1 )
                        shoudBeBroken1 = true
                        break
                      }
                    }
                    if( shoudBeBroken1 ) break
                  }
      
                  newBuyInChips = JSON.parse( JSON.stringify( chipsForReplacement ))
      
                  shoudBeBroken = true
      
                  break
                }
              }
              if( shoudBeBroken ) break
            }
          }
        }
  
      }else{
        ( 'smallBlind is '  + smallBlind )
      }
    }


    flatChips = [...buyInChips].flat()

    // console.log( 'newBetChips' )
    // console.log( newBetChips.toString() )
    showBetChips ? setBetChips( newBetChips ) : null
    setBuyInChips( newBuyInChips )
  }

  function sortFlatChips( chips, commonChip ) {
    // Separate the array into three parts
    let equalToVariable = [];
    let lessThanVariable = [];
    let greaterThanVariable = [];

    // Iterate through the array and categorize the numbers
    chips.forEach(num => {
      if( num === commonChip ) {
        equalToVariable.push(num);
      } else if ( num < commonChip ) {
        lessThanVariable.push( num );
      } else {
        greaterThanVariable.push(num);
      }
    })

    // Concatenate the arrays in the desired order
    return [...equalToVariable.flat(), ...lessThanVariable.flat(), ...greaterThanVariable.flat()];
  }

  function generateChips( currentBuyIn, buyInChips, maxArrayAmount, smallBlind ) {
    
    const newChips = JSON.parse( JSON.stringify( buyInChips )) // Deep copy  
    const validDenominations = chipDenominations.filter( denomination => denomination <= smallBlind )
    const closestDenomination = Math.max( ...validDenominations )
    let mainPartOfChips;

  
    // main part of chips are chips that equal small blind. But the main part can't consist more than 15 chips
    // mainPartOfChips = Math.floor( 0.5 * currentBuyIn )
    if( Math.floor( 0.5 * currentBuyIn ) / closestDenomination <= 15 ){
      mainPartOfChips = Math.floor( 0.5 * currentBuyIn )
    }else{
      mainPartOfChips = 15 * closestDenomination
    }

    const updateMainPartOfChips = () => {
      if( Number.isInteger( mainPartOfChips ) && smallBlind ){
        if( mainPartOfChips % closestDenomination !== 0 ){
          mainPartOfChips += 1
          updateMainPartOfChips()
        }
      }
    }
  
    updateMainPartOfChips()
    
  
    const restOfChips = currentBuyIn - mainPartOfChips
    const chipsForMainPartOfChips = Math.floor( mainPartOfChips / closestDenomination )
  
    for( let i = 0; i < chipsForMainPartOfChips; i++ ) {
      const randomArrayIndex = getRandomInt( 0, maxArrayAmount ) // Choose a random array
      newChips[ randomArrayIndex ].push( closestDenomination )
    }
  
    let remainingBet = restOfChips

    for (const denom of chipDenominations) {
      let stackIndex = 0;
      while( remainingBet >= denom && stackIndex < newChips.length ) {
        newChips[ stackIndex ].push( denom )
        remainingBet -= denom
        stackIndex++
      }
    }

    return newChips
  }

  function getRandomInt( min, max ) {
    return Math.floor( Math.random() * ( max - min )) + min
  }

  return(
    <div className={ className }>
      { chipsStack }
      <div className='betChips'>
        { betStack }
        <GetBuyInAfterBankrupt
          roomData = { roomData }
          participant = { participant }
          user = { user }
          toggleGetChips={ toggleGetChips }
          socket={ socket }
        />
      </div>
    </div>
  )

}

export default ChipsStack